/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowfailed2Inputs */

const en_aiflowfailed2 = /** @type {(inputs: Aiflowfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That didn't work. Please try again.`)
};

const de_aiflowfailed2 = /** @type {(inputs: Aiflowfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das hat nicht geklappt. Versuch es noch einmal.`)
};

/**
* | output |
* | --- |
* | "That didn't work. Please try again." |
*
* @param {Aiflowfailed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowfailed2 = /** @type {((inputs?: Aiflowfailed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowfailed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowfailed2(inputs)
	return de_aiflowfailed2(inputs)
});
export { aiflowfailed2 as "aiFlowFailed" }